import styled from 'styled-components';
import {accentColorTertiary, bpXl, fontColorPrim, white} from "../../assets/styledAssets/vars";
import * as CSS from "csstype";

export const Header = styled.div`
  position:fixed;
  top:0;
  right:0;
  left:0;
  z-index:3;
  background-color: ${white};
  height:7rem;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:0 2.4rem;
  + div{
    margin-top:7rem;
    max-height: calc(100% - 7rem);
  }
  @media(min-width:${bpXl}){
    display:none;
    + div{
      margin-top:0;
      max-height:100%;
    }
  }
`;

interface StyledBodyProps{
  isSidebarShow: boolean
}

export const StyledBody = styled.div<Partial<CSS.Properties & StyledBodyProps>>`
  display: flex;
  background-color: ${accentColorTertiary};
  flex-direction: column;
  justify-content: flex-start;
  padding: 3rem 3rem 0 3rem;
  max-height: 100%;
  margin-left: 0; 
  width:100%; 
  max-width:100%;
  height:100vh;
  flex-wrap:nowrap;
  overflow:hidden;
  position:relative;
  ${(props) => props.isSidebarShow && `    
     margin-left:0;
     max-width:100%;
     position:fixed;
     z-index:7;
      &:before{
        content:"";
        position:fixed;
        top:0;
        left:0;
        bottom:0;
        right:0;
        z-index:3;
        background-color:${fontColorPrim};
        opacity:.24;
      }
  `}
  @media(min-width:${bpXl}){
    padding: 5rem 3rem 0 3rem;
    margin-left:auto;
    max-width:calc(100% - 30rem);
    ${(props) => props.isSidebarShow && `
      max-width:calc(100% - 30rem)
      &:before{display:none;}
    `}
  }
`;